import { useEffect, useState } from 'react';

/**
 * A value that follows another one once it has stopped changing.
 *
 * @param value the value as it changes, such as what is being typed
 * @param delayMs how long it must hold still before it is passed on
 * @returns the last value that held still for the whole delay
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = window.setTimeout(() => {
      setSettled(value);
    }, delayMs);
    return () => {
      window.clearTimeout(timer);
    };
  }, [value, delayMs]);
  return settled;
}
